module.exports = __webpack_public_path__ + "img/zone100350.8ae9c06d.png";